import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { NzTreeComponent } from "ng-zorro-antd/tree";
import { NzFormatEmitEvent } from "ng-zorro-antd/core";
import * as _ from "lodash";

import {
  ISelectedNode,
  ITreeData,
  ICheckedTree,
  ITreeEvent
} from "../../../tools/util";

@Component({
  selector: "kreform-private-tree",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"]
})
export class KreFormPrivateTree implements OnInit, OnChanges {
  //是否显示Tag
  @Input() tag: boolean = true;

  //单选？多选
  @Input() selectType: "single" | "multiple" = "single";

  @Input() expandAll:boolean = true;

  //选中节点
  @Input() selectData: ICheckedTree[] = [];

  //树数据
  @Input() data: ITreeData[] = [];

  @Output() treeChangeEvent = new EventEmitter<ITreeEvent>();

  @ViewChild("nzTreeComponent", { static: false })
  nzTreeComponent: NzTreeComponent | undefined;

  selectedKey: any[] = [];

  //选择节点
  selectedNode: ISelectedNode[] = [];

  skeletonStatus: number = 0;
  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectData) {
      this.treeChecked(this.selectData);
    }
    if (changes.data) {
      //setTimeout(() => {
      this.skeletonStatus = 1;
      //}, 100);
    }
  }

  nzClick(event: NzFormatEmitEvent) {
    if (this.selectType != "multiple") {
      this.selectData.forEach((item: any, index, object) => {
        if (
          item != undefined &&
          item != null &&
          item.value != undefined &&
          item.value != null &&
          event != undefined &&
          event != null &&
          event.node != undefined &&
          event.node != null &&
          event.node.key != undefined &&
          event.node.key != null &&
          event.node.title != undefined &&
          event.node.title != null &&
          item.value !== event.node.key
        ) {
          object.splice(index, 1);
        }
      });
      if (this.selectData.length < 1) {
        if (
          event != undefined &&
          event != null &&
          event.node != undefined &&
          event.node != null &&
          event.node.key != undefined &&
          event.node.key != null &&
          event.node.title != undefined &&
          event.node.title != null
        ) {
          this.selectData.push({
            label: event.node.title,
            value: event.node.key
          });
        }
      }
      this.treeChangeEvent.emit({ checkData: this.selectData });
    }
  }

  //点击复选框触发
  nzCheck(event: NzFormatEmitEvent): void {
    if (
      event != undefined &&
      event != null &&
      event.keys != undefined &&
      event.keys != null &&
      event.node != undefined &&
      event.node != null &&
      event.node.key != undefined &&
      event.node.key != null &&
      event.node.title != undefined &&
      event.node.title != null
    ) {
      let isAdd: boolean = event.keys.some((key: any) => {
        return key === _.get(event, "node.key");
      });
      if (isAdd == true) {
        this.selectData.push({
          label: event.node.title,
          value: event.node.key
        });
      } else {
        this.selectData.forEach((item, index, object) => {
          if (item.value === _.get(event, "node.key")) {
            object.splice(index, 1);
          }
        });
      }
    }
    this.treeChecked(this.selectData);

    this.treeChangeEvent.emit({ checkData: this.selectData });
  }

  //重置选中节点
  treeChecked(items: any) {
    if (items != null && items.length > 0) {
      this.selectedKey = items.map((item: any) => {
        return item.value;
      });
    } else {
      this.selectedKey = [];
    }
  }

  //删除选中节点
  selectClearById(node: any) {
    this.selectData.forEach((item, index, object) => {
      if (item.value === node) {
        object.splice(index, 1);
      }
    });
    this.treeChecked(this.selectData);
    this.treeChangeEvent.emit({ checkData: this.selectData, delete: node });
  }

  selectAllClear(){  
    //this.selectData =[];
  }
}
